import { create } from "zustand";
import { doctorAppointmentApi, doctorDashboard } from "../api_layer/api";
import { doctorDashboardPage } from "../api_layer/api";
import { writeBulkPrescription } from "../api_layer/api";
import { myAppointmentData } from "../api_layer/api";

const useDoctorDashboardStore = create((set, get) => ({
  dashboardData: [],
  appointmentData: [],
  dashboardLoading: false,
  appointmentLoading: false,
  postLoading: false,
  error: null,
  postError: null,
  startDate: null,
  endDate: null,
  docBookingData: [],
  appointLoading: false,

  fetchDashboardData: async (queryParams) => {
    try {
      set({ dashboardLoading: true, error: null });
      const response = await doctorDashboard(queryParams);
      set({ dashboardData: response.data, dashboardLoading: false });
    } catch (error) {
      set({ error: error.message, dashboardLoading: false });
    }
  },
  fetchAppointmentData: async (start, end) => {
    const { startDate, endDate } = get();
    if (start) {
      set({ startDate: start, endDate: end });
    }
    try {
      set({ appointmentLoading: true, error: null });
      const response = await myAppointmentData(
        start ?? startDate,
        end ?? endDate
      );

      set({ appointmentData: response.data, appointmentLoading: false });
    } catch (error) {
      set({ error: error.message, appointmentLoading: false });
    }
  },
  fetchDoctorDashboardData: async (page = "1") => {
    try {
      set({ dashboardLoading: true, error: null });
      const response = await doctorDashboardPage(page);
      set({ dashboardData: response.data, dashboardLoading: false });
    } catch (error) {
      set({ error: error.message, dashboardLoading: false });
    }
  },
  fetchDoctorAppointmentData: async (caseId, setData) => {
    try {
      set({ appointLoading: true, error: null });
      const response = await doctorAppointmentApi(caseId);
      const slots = response.data?.map((item) => {
        if (item.payment_status == "system" && !item.isFollowUp ) {
          return { tag: "Intervention Call", ...item };
        } else if(item.isFollowUp && item.booking_type === 'follow_up_medical') {
          return { tag: "Follow Up Intervention", ...item };
        }
        else if (item.isFollowUp) {
          return { tag: "Follow Up Call", ...item };
        } else if (item.booking_type == "clinic_appointment") {
          return { tag: "Offline Appointment", ...item };
        } else if (item.payment_status == "paid") {
          return { tag: "Paid Call", ...item };
        } else if (item.payment_status == "free") {
          return { tag: "Direct Call", ...item };
        } else {
          return { tag: "499 Call", ...item };
        }
      });
      setData(slots);
      set({ docBookingData: response.data, appointLoading: false });
    } catch (error) {
      set({ error: error.message, appointLoading: false });
    }
  },
  postWritePrescription: async (data, setToaster) => {
    const callFunction = data?.map((item) => {
      return writeBulkPrescription(item);
    });
    try {
      Promise.all(callFunction)
        .then((data) => {
          setToaster(
            "Bulk Prescription",
            "Bulk Prescription Updated",
            "success"
          );
        })
        .catch((error) => {
          setToaster(
            "Bulk Prescription",
            "One or more Bulk prescription Failed",
            "danger"
          );
        });
    } catch (error) {
      set({ postError: error.message, postLoading: false });
    }
  },
}));

export default useDoctorDashboardStore;
